/**
 * User: nir
 * Date: 06/10/2016
 * Time: 9:51
 */

if (window['jQuery'] && window['TCTServer'] && window['TCTServer']['ajax_url'] && !window['TCTServer']['admin']) {
    window.jQuery(function ($) {
        var containers = $('[data-ajax]');
        if (!containers || !containers.length) return;

        containers.each(function (i, e) {
            var container = $(e),
                loading = container.next('.loading-info'),
                data = container.data();

            // bail if not relevant
            if (!data || !data.ajax) return;

            // set action data parameter
            data.action = 'tct_get_' + data.ajax.replace(/-/g, '_');

            // remove the ajax data parameter as it is not needed
            delete data.ajax;

            loading.toggleClass('loading', true).fadeIn('fast');

            $.ajax({
                url: window['TCTServer']['ajax_url'],
                data: data,
                success: function (response) {
                    if (response) {
                        container.append(response);
                        TCT.loadHDImages();
                    } else {
                        container.parent().remove();
                    }
                },
                error: function () {
                    container.parent().remove();
                },
                complete: function () {
                    loading.fadeOut('fast', function () {
                        $(this).remove();
                    });
                }
            });
        });
    });
}